// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"accb5eb257b80faa7d84","966":"10c73117bb64ec8963af"}[chunkId] + ".js";
};